//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

// How long an admin list stays fresh. Finite, so another admin's change still
// arrives on focus within a few minutes; long enough that the client's global
// focus-refetch does not re-read the list on every tab switch while the pane
// is open. This session's own writes seed the list directly.
export const ADMIN_LIST_STALE_MS = 5 * 60_000;
